import { AfterViewInit, ChangeDetectorRef, Component, DoCheck, ElementRef, HostListener, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { IonContent, Platform } from '@ionic/angular';
import { AppState } from 'src/app/app.service';
import { I18n } from 'src/app/i18n.service';
import { KyperChapters, Path } from 'src/app/path/path-v2.model';
import * as _ from 'underscore';
import { HomeUiService } from '../home-ui.service';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/user/user.model';
import { ToasterService } from 'src/app/toaster.service';
import { HomeV5Service } from 'src/app/pages/home-v5/home-v5.service';
import { HttpClient } from '@angular/common/http';
import Swiper from 'swiper';
import { DailyStepsContentWebModalV2Component } from '../daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { AnimationsService } from 'src/app/shared/animations.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MyCommitmentsComponent } from 'src/app/my-commitments/my-commitments.component';
import { AllPathsV2Component } from 'src/app/all-paths-v2/all-paths-v2.component';
import { AlertUnlockLevelComponent } from 'src/app/alert-unlock-level/alert-unlock-level.component';
import { SessionService } from 'src/app/session/session.service';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import { FooziAiConciergeService } from '../foozi-ai-concierge.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { collapseAnimation, collapseOnLeaveAnimation, expandOnEnterAnimation, slideOutRightAnimation } from 'angular-animations';
import { DailySteps, ScreenTypes } from 'src/app/path/path-daily-steps-v2.model';
import { DomSanitizer } from '@angular/platform-browser';

export interface ExcludedSteps {
  steps,
  completedSteps,
  activeStep,
  notStartedStep,
  totalSteps
}
@Component({
  selector: 'app-your-path-new',
  templateUrl: './your-path-new.component.html',
  styleUrls: ['./your-path-new.component.scss'],
  animations: [
   slideOutRightAnimation({duration: 500}),
   collapseAnimation(),
   expandOnEnterAnimation({ duration: 250 }),
   collapseOnLeaveAnimation({ duration: 250 })
  ]
})
export class YourPathNewComponent implements OnInit, AfterViewInit,DoCheck,OnDestroy {

  isMobile: boolean
  path: Path
  currentDay: number
  @ViewChildren("stepTitle") stepTitle: QueryList<ElementRef>;
  @ViewChildren("stepTitleStart") stepTitleStart:QueryList<ElementRef>;
  @ViewChildren("stepTitleEnd") stepTitleEnd:QueryList<ElementRef>;
  @ViewChild('focusableEndChapter') focusableEndChapter: ElementRef;
  @ViewChild(IonContent) content: HTMLIonContentElement;
  @ViewChild('contentWrapper') contentWrapper: ElementRef;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChildren('chapterCard') chapterCards: QueryList<ElementRef>;
  @ViewChildren('stepCards') stepCards: QueryList<ElementRef>;
  @ViewChildren('finishStepCards') finishStepCards: QueryList<ElementRef>; 
  currentUser: User
  pathRegistration: any
  scheduleDay: number
  focusYourPath=false;
  sectionSize: any[] = [];
  rightSwipe;
  leftSwipe;
  isHovered = false;
  startPlayButton;
  onFocusPlayBtn;
  dailyStepsArray;
  blurPlayButton;
  @ViewChild('swiperContainer') swiperContainer: any;
  swiper: Swiper;
  destroyed$ = new Subject<boolean>();
  playSvg;
  closeoutSvg;
  onFocuseCloseOut;
  isBtnFocused =false;
  isMobileWebIos = false;
  isMobileWeb=false;
  startCloseout;
  isScrollbarPresent;
  allPathsCount;
  allCohortsCount
  isTouchDevice
  isModalOpen = false;
  expandedIndex: number | null = null;
  isExpandedCard1 = false;
  isExpandedCard2 = false;
  isDataLoading = false;
  private viewEntered = false;
  private pendingRender = false;
  chaptersInfo: any =[]; // static data
  finalSortedChaptersInfo: any[] = []
  initialChapterStepsInfo:ExcludedSteps;
  finalChaptertepsInfo:ExcludedSteps;
  finalizedChapterIds = []
  userShuffledChapters;
  pathPersonalizationScreeInfo;
  activeChapterIndex;
  actionScreenTitle;
  assessmentScreenTitle;
  reflectionScreenTitle
  socialScreenTitle
  habitsScreenTitle
  pollScreenTitle;
  activestepIndex ;
  constructor(private appState: AppState,
    private router: Router,
    private el : ElementRef,
    public i18n: I18n,
    public http: HttpClient,
    public platform: Platform,
    private modalController: ModalController,
    public homeUIService: HomeUiService,
    private render:Renderer2,
    private homev5Service: HomeV5Service,
    private animationService: AnimationsService,
    private sessionService: SessionService,
    private routineService: RoutineService,
    private sanitizer: DomSanitizer,
    public toasterService: ToasterService,
    private fooziAiService: FooziAiConciergeService,
    private cdRef: ChangeDetectorRef) {
    this.isMobile = this.appState.get('isMobile')
    this.path = this.appState.get('currentPath')
    this.currentDay = this.appState.get('currentScheduleDay')
    this.currentUser = this.appState.get('currentUser')
    this.scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.pathRegistration = this.appState.get('pathRegistration')
    this.dailyStepsArray = this.appState.get("DailyStepsData");
    this.activestepIndex= this.appState.get('currentActiveStepIndex')
    this.sectionSize = [
      {
        size:4, sizeMd:4,sizeSm:5,sizeLg:3.5,sizeXl:3
       },
      {
        size:8, sizeMd:8,sizeSm:7,sizeLg:8.5,sizeXl:9
      }
    ]
   }
 
  fetchScreenTypeContent(screentype) {
   let dailyStepsArray = this.appState.get('DailyStepsData')
    return dailyStepsArray
      .map(step => step?.[screentype])
      .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
      .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  ngOnInit() {
    this.activestepIndex= this.appState.get('currentActiveStepIndex')
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.chaptersInfo =  this.appState.get("DailyStepsData");
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.allPathsCount =  this.appState.get('allPathCount')
    this.allCohortsCount = this.appState.get('cohortPathsCount')
    this.loadSvgFile('../../../assets/web_home_ui/white_play_btn.svg');
    this.loadSvgFile('../../../assets/web_home_ui/black_play_btn.svg');
    this.loadSvgFile('../../../assets/web_home_ui/black_circular-to-do.svg');
    this.loadSvgFile('../../../assets/web_home_ui/white_circular_to-do.svg');
    this.loadSvgFile('../../../assets/web_home_ui/blur-play-btn.svg');
   this.getStepArrayInfo();
   this.homeUIService.refreshStepApiData.pipe(takeUntil(this.destroyed$)).subscribe( (data) => {
    if(data){
      console.log("data in your cycle", data);
      this.dailyStepsArray = data.data;
      this.chaptersInfo = this.appState.get("DailyStepsData");
      this.activeChapterIndex = data.currentChapter?.position;
      this.activestepIndex= data.currentChapter?.currentStep?.chapterStepIndex;
      this.filterStepsByContentType();
      if (this.isMobile && !this.viewEntered) {
        // Defer DOM render until ionViewDidEnter so chapter cards don't enter
        // the DOM during Ionic's slide animation — that conflict clips step-title-container.
        this.pendingRender = true;
        return;
      }
      this.fetchChaptersSteps();
      this.isDataLoading = false;
      this.cdRef.detectChanges();
    }

  });
  this.fooziAiService.expandHamburger.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
    let col1, col2;
    console.log("called datat",data)
    if (data) {
       col1 = {
        size:5, sizeMd:5,sizeSm:6,sizeLg:4.5,sizeXl:4.5
      }
      col2 = {
        size:7, sizeMd:7,sizeSm:6,sizeLg:7.5,sizeXl:7.5
      }
    }
    else {
       col1 = {
        size:4.5, sizeMd:4.5,sizeSm:5,sizeLg:3.5,sizeXl:3
       }
      col2 = {
        size:7.5, sizeMd:7.5,sizeSm:7,sizeLg:8.5,sizeXl:9
      }
    }
    this.sectionSize = [col1, col2];
  });
    if (this.finalSortedChaptersInfo?.length === 0) {
      this.isDataLoading = true;
    }
  }

  ionViewWillLeave() {
    this.viewEntered = false;
    this.pendingRender = false;
  }

  ionViewDidEnter() {
    this.viewEntered = true;
    if (this.pendingRender) {
      this.pendingRender = false;
      this.fetchChaptersSteps();
      this.isDataLoading = false;
      this.cdRef.detectChanges();
    } else if (this.finalSortedChaptersInfo?.length > 0) {
      this.cdRef.detectChanges();
    }
  }

  updateChapterStepStatus() {
    this.chaptersInfo =  this.appState.get("DailyStepsData");
    const isFinalised = this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised;
    if ((this.finalSortedChaptersInfo?.length<this.chaptersInfo?.length|| this.activeChapterIndex ==0 ||this.finalSortedChaptersInfo?.length==0) && this.userShuffledChapters && this.userShuffledChapters?.chapterOrder && isFinalised) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !this.userShuffledChapters.chapterOrder.includes(c.id));

        const orderedChapters = this.userShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      // Update the initial chapter steps info
    }
    if (this.finalSortedChaptersInfo?.length > 0) {
      if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder&& (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised)) {
        this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
        this.activeChapterIndex = this.appState.get('currentActiveChapter')

        this.finalSortedChaptersInfo.forEach((chapter) => {
          const matched = (this.chaptersInfo as any[]).find((c: any) => c.id === chapter.id);
          const includedSteps = matched?.steps ?? chapter.steps;
          chapter.steps = includedSteps;
          chapter.completedSteps = includedSteps?.filter(s => s?.stepStatus == 'Review')?.length;
          chapter.activeStep = includedSteps?.filter(
            s => s.stepStatus == 'Resume' || (s.position == this.scheduleDay && s.stepStatus !== 'Review')
          )?.length;
          chapter.notStartedStep = includedSteps?.filter(
            s => s.position == this.scheduleDay && !s.stepStatus
          )?.length;
          chapter.totalSteps = includedSteps?.length;
        });
      }
      else {
        this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
        this.activeChapterIndex = this.appState.get('currentActiveChapter')
        this.finalSortedChaptersInfo?.forEach((chapter) => {
          const matched = (this.chaptersInfo as any[]).find((c: any) => c.id === chapter.id);
          const includedSteps = matched?.steps ?? chapter.steps;
          chapter.steps = includedSteps;
          chapter.completedSteps = includedSteps?.filter(s => s?.stepStatus == 'Review')?.length;
          chapter.activeStep = includedSteps?.filter(
            s => s?.stepStatus == 'Resume' || (s?.position == this.scheduleDay && s?.stepStatus !== 'Review')
          )?.length;
          chapter.notStartedStep = includedSteps?.filter(
            s => s?.position == this.scheduleDay && !s?.stepStatus
          )?.length;
          chapter.totalSteps = includedSteps?.length;
        });
      }
    }

    let time = this.isMobile ? 0 : 500
     if (this.finalSortedChaptersInfo?.length > 0) {
     setTimeout(async () => {
        await this.swipeToActiveSlide(100); 
      },time);
    }
    // expandCardForSteps() is only called from fetchChaptersSteps() to avoid a jerk from an intermediate wrong expandedIndex.
    // this.expandCardGetStarted();
    // this.expandCardFinishStarted();
  }

  fetchChaptersSteps(skipExpand = false) {
  //   let onboardingStepsData =this.dailyStepsArray
  // .map(step => step.onboardingSteps)
  // .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  // .flatMap(s => Array.isArray(s) ? s : [s]);
  //   if (onboardingStepsData?.length>0) {
  //      this.pathPersonalizationScreeInfo = onboardingStepsData.filter(s=>s.stepTypes == 'pathPersonalization')
    //   }

     if (this.chaptersInfo?.length > 0) {
      this.activeChapterIndex = this.appState.get('currentActiveChapter');
       this.activestepIndex = this.appState.get('currentActiveStepIndex');

       // Search ALL chapters for the pathPersonalization screen (not just Chapter 0)
       let ppChapterIndex = -1;
       for (let ci = 0; ci < this.chaptersInfo.length; ci++) {
         const steps = this.chaptersInfo[ci]?.steps;
         if (steps?.length > 0) {
           const stepIdx = steps.findIndex((step: any) =>
             step?.screens?.some((s: any) => s?.screenType === 'pathPersonalization')
           );
           if (stepIdx !== -1) {
             ppChapterIndex = ci;
             this.pathPersonalizationScreeInfo = this.path.filterStepsByContentType('pathPersonalization', steps[stepIdx]);
             break;
           }
         }
       }

    // //  Reorder chapters as per chapterorder , neeed to uncomment when working on reoder chapters flow
      if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder && (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised)) {
        // Find chapters NOT in order list
        const missingChapters = this.chaptersInfo.filter(c => !this.userShuffledChapters.chapterOrder.includes(c.id));
        const orderedChapters = this.userShuffledChapters?.chapterOrder
          .map(id => this.chaptersInfo.find(c => c.id === id))
          .filter(Boolean); // remove undefined if any

        // Final reordered chapters (missing first, then ordered ones)
        this.finalSortedChaptersInfo = [...missingChapters, ...orderedChapters];
      }
      else {
        if (this.pathPersonalizationScreeInfo?.length > 0) {
          const chaptersUpToPP = this.chaptersInfo.slice(0, ppChapterIndex + 1);
          if (this.chaptersInfo.length - chaptersUpToPP.length === 1) {
            // Exactly 1 chapter is hidden — user can never finalize, so show all chapters.
            this.finalSortedChaptersInfo = this.chaptersInfo;
          } else {
            // Multiple chapters hidden — show only up to the path personalization chapter until finalized.
            this.finalSortedChaptersInfo = chaptersUpToPP;
          }
        } else {
          this.finalSortedChaptersInfo = this.chaptersInfo;
        }
     }
      this.scheduleDay = this.appState.get('scheduleDayForCurrentStep')
      this.activeChapterIndex = this.appState.get('currentActiveChapter');
 
      // Attach steps for each chapter based on start_step & end_step
       if (this.userShuffledChapters && this.userShuffledChapters?.chapterOrder && (this.userShuffledChapters?.is_finalised ?? this.userShuffledChapters?.isFinalised) ) {
         this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
          const includedSteps = chapter.steps ?? [];
           const completedStepsLength = includedSteps.filter(s => s.stepStatus == 'Review')
           const activeStep = includedSteps.filter(s => s.stepStatus == 'Resume' || (s?.position == this.scheduleDay && s.stepStatus !== 'Review'))
           const notStartedStep = includedSteps.filter(s => s.position == this.scheduleDay && !s.stepStatus)
           return { ...chapter, steps: includedSteps, completedSteps: completedStepsLength?.length, activeStep: activeStep?.length, notStartedStep: notStartedStep?.length, totalSteps: includedSteps?.length };
         });
       }
       else if(this.finalSortedChaptersInfo?.length>0){
          this.finalSortedChaptersInfo = this.finalSortedChaptersInfo.map(chapter => {
        const includedSteps = chapter.steps ?? [];
        const completedStepsLength = includedSteps.filter(s => s.stepStatus == 'Review')
        const activeStep= includedSteps.filter(s=>s.stepStatus=='Resume'|| (s.position==this.scheduleDay && s.stepStatus !== 'Review'))
        const notStartedStep = includedSteps.filter(s =>  s.position == this.scheduleDay && !s.stepStatus)
        return { ...chapter, steps: includedSteps, completedSteps: completedStepsLength?.length, activeStep: activeStep?.length, notStartedStep: notStartedStep?.length, totalSteps: includedSteps?.length };
      });
       }
      let time = this.isMobile ?0 : 500
     setTimeout(async () => {
        await this.swipeToActiveSlide(100);
      },time);
      console.log(this.finalSortedChaptersInfo);
     }
    if (!skipExpand) {
      this.expandCardForSteps();
    }
    // this.expandCardFinishStarted();
  }
  areAllChaptersStepsReviewed() {
    return this.dailyStepsArray?.length > 0 && this.dailyStepsArray.every(chapter =>
      chapter?.steps?.every(step => step?.stepStatus === "Review")
    );
  }
  progressBarGradient(chapterInfo) {
    let totSteps = chapterInfo?.totalSteps;
    if (!totSteps) return '0%';
    let currentStep =
      chapterInfo?.completedSteps === 0 && chapterInfo?.activeStep === chapterInfo?.notStartedStep
        ? 0
        : chapterInfo?.completedSteps > 0
          ? chapterInfo?.completedSteps + (chapterInfo?.activeStep === chapterInfo?.notStartedStep ? 0 : chapterInfo?.activeStep / 2)
          : chapterInfo?.activeStep / 2;
    const stepSize = 100 / totSteps;
    const stepPercentage = stepSize * currentStep;
    const completedStepGradient = `${stepPercentage}%`;
    return completedStepGradient;
  }
  progressStepBarGradient(currentStep) {
    let data = this.appState.get("screensViewed")
    if (!data || data == undefined) {
      if (this.appState.get('pathRegistration')) {
        data = this.appState.get('pathRegistration')?.screensViewed
      }
      else {
        return 0;
      }
    }
    let stepObjects
    if (data) {
      stepObjects = data.filter(item => item.step === currentStep?.position);
    }
    if (stepObjects?.length === 0 || !data) return 0;

    // take the last one
    const lastStep = stepObjects[stepObjects?.length - 1];
    if (!lastStep?.totalScreens) return '0%';
    const stepPercentage = (lastStep?.visitedScreens / lastStep?.totalScreens) * 100;
    const completedStepGradient = `${stepPercentage}%`;
    return completedStepGradient;
  }

  toggleCard(index: number) {
        let time = this.isMobile ? 0 : 500;
    this.expandedIndex = this.expandedIndex === index ? null : index;
      // this.swipeToActiveSlide(time, 'middleChapter')
  }


  toggleCardSingle(card: 'card1' | 'card2') {
    let time = this.isMobile ? 0 : 500;
    if (card === 'card1') {
      this.isExpandedCard1 = !this.isExpandedCard1;
    } else if (card === 'card2') {
      this.isExpandedCard2 = !this.isExpandedCard2;
        this.swipeToActiveSlide(time, 'endChapter')
    }
  }

  getStepArrayInfo(){
     let stepBegin= false;
      let stepCount = 1;
      this.dailyStepsArray?.forEach((chapter: any) => {
          chapter?.steps?.forEach((stepItem: DailySteps, i) => {
            if (stepItem?.stepStatus === "Review" && i < chapter?.steps?.length) {
              stepCount += 1
              this.appState.set('scheduleDayForCurrentStep', stepCount);
              this.appState.set("currentScheduleDay", stepCount);
            }
            else if (stepItem?.stepStatus == 'Resume') {
              this.appState.set("currentScheduleDay", stepCount)
              this.appState.set('scheduleDayForCurrentStep', stepCount);
              stepBegin = true
            }
            else if (!stepItem?.stepStatus && !stepBegin) {
              this.appState.set("currentScheduleDay", stepCount)
              this.appState.set('scheduleDayForCurrentStep', stepCount);
              stepBegin = true
            }
          });
        });
    this.updateChapterStepStatus();
    this.filterStepsByContentType();
  }

  isAllItemsVisible() {
    const slidesPerView = +this.swiper.params.slidesPerView;
    const totalSlides = this.swiper.slides.length;
    const activeIndex = this.swiper.activeIndex;
    return activeIndex + slidesPerView >= totalSlides;
  }

expandCardForSteps(): void {
  if (!this.finalSortedChaptersInfo || this.finalSortedChaptersInfo.length === 0) {
    return;
  }
  for (let i = 0; i < this.finalSortedChaptersInfo.length; i++) {
    const chapter = this.finalSortedChaptersInfo[i];  
    if (!chapter || !Array.isArray(chapter.steps)) {
      continue;
    }
    const hasResumeStep = chapter.steps.some(step =>
      step?.stepStatus == 'Resume' || (step.position == this.scheduleDay && step.stepStatus !== 'Review')
    );
    if (hasResumeStep) {
      this.expandedIndex = i;
      break;
    }
    else {
      this.expandedIndex = null
    }
  }
}

expandCardGetStarted(): void {
  if (!this.initialChapterStepsInfo?.steps) return;
  const hasResumeStep = this.initialChapterStepsInfo.steps.some(
    step => step?.stepStatus == 'Resume' || (step.position == this.scheduleDay && step.stepStatus !== 'Review')
  );
  if (hasResumeStep) {
    this.isExpandedCard1 = true;
  }
  else {
    this.isExpandedCard1 = false;
  }
}
expandCardFinishStarted(): void {
  if (!this.finalChaptertepsInfo?.steps) return;
  const hasResumeStep = this.finalChaptertepsInfo.steps.some(
    step => step?.stepStatus == 'Resume' || (step.position == this.scheduleDay && step.stepStatus !== 'Review')
  );
  if (hasResumeStep) {
    this.isExpandedCard2 = true;
  }
  else 
  {
    this.isExpandedCard2 = false; 
  }
}
  filterStepsByContentType() {
    let types=['assessment','action','reflection','social','habits','poll']
    types.forEach((type: ScreenTypes) => {
      this.getScreenTitleByType(type);
    });
  }

  getScreenTitleByType(type: ScreenTypes) {
    let stepScreens = this.dailyStepsArray[this.activeChapterIndex]?.steps[this.activestepIndex]?.screens
    let res = stepScreens?.filter(screen => screen?.screenType === type)
    let finalResult = res?.length > 0 ? res[0]?.screenContents?.content?.title?res[0]?.screenContents?.content?.title:res[0]?.screenContents?.content?.heading : null
    switch (type) {
      case 'assessment':
        this.assessmentScreenTitle = finalResult;
        break;
      case 'action':
        this.actionScreenTitle = finalResult;
        break;
      case 'reflection':
        this.reflectionScreenTitle = finalResult;
        break;
      case 'social':
        this.socialScreenTitle = finalResult;
        break;
      case 'habits':
        this.habitsScreenTitle = finalResult;
        break;
      case 'poll':
        this.pollScreenTitle = finalResult;
        break;
    }
            console.log("type is",type, finalResult)

  }
  ngDoCheck(): void {
    // this.dailyStepsArray= this.appState.get("DailyStepsData");
    this.allPathsCount = this.appState.get('allPathCount')
    this.allCohortsCount = this.appState.get('cohortPathsCount')
    this.userShuffledChapters = this.appState.get('userShuffledChapters');
    this.scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.activeChapterIndex = this.appState.get('currentActiveChapter')
    this.activestepIndex= this.appState.get('currentActiveStepIndex')
    this.currentDay = this.appState.get('currentScheduleDay')
    this.path = this.appState.get('currentPath');
  }

  scrollToMiddleChaptersStep() {
    let flatIndex = 0;
    for (let chapter of this.finalSortedChaptersInfo) {
      for (let step of chapter.steps) {
        const shouldScroll =
          chapter.activeStep > 0 &&
          (step.position === this.scheduleDay || step.stepStatus === 'Resume');
        if (shouldScroll) {
          const card = this.stepCards.toArray()[flatIndex];
          if (card && card?.nativeElement && this.isMobile) {
            this.content.scrollToPoint(
              0,
              //  card.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              card.nativeElement.offsetTop + 20
           )
          }
          else if (card && card?.nativeElement && !this.isMobile) {
            
            const elementRect = card?.nativeElement?.getBoundingClientRect();
            const parentContainer = this.scrollContainer?.nativeElement?.getBoundingClientRect();
            const offsetTop = elementRect?.top - parentContainer?.top + this.scrollContainer?.nativeElement?.scrollTop - 20;
            this.scrollContainer?.nativeElement?.scrollTo({
              top: offsetTop,
              behavior: 'smooth', 
            })
          }
          // return;
        //}
      }
      flatIndex++;
    }
  }
  }
   scrollTofinalChaptersStep() {
    let flatIndex = 0;
    if(this.finalChaptertepsInfo?.totalSteps>0) {
      //for (let step of chapter.steps) {
      this.finalChaptertepsInfo?.steps.forEach((step) => {
        const shouldScroll =
          this.finalChaptertepsInfo?.activeStep > 0 &&
          (step.position === this.scheduleDay || step.stepStatus === 'Resume');
        if (shouldScroll) {
          const card = this.finishStepCards?.toArray()[flatIndex];
          // if (card && card?.nativeElement) {
          //   this.content.scrollToPoint(
          //     0,
          //     card.nativeElement.offsetTop + 20
          //   )
          // }
          if (card && card?.nativeElement && this.isMobile) {
            this.content.scrollToPoint(
              0,
              //  card.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              card.nativeElement.offsetTop + 20
           )
          }
          else if (card && card?.nativeElement && !this.isMobile) {
            
            const elementRect = card?.nativeElement?.getBoundingClientRect();
            const parentContainer = this.scrollContainer?.nativeElement?.getBoundingClientRect();
            const offsetTop = elementRect?.top - parentContainer?.top + this.scrollContainer?.nativeElement?.scrollTop - 20;
            this.scrollContainer?.nativeElement?.scrollTo({
              top: offsetTop,
              behavior: 'smooth', 
            })
          }
          // return;
          //}
        }
        flatIndex++;
      });
  }
  }
  /**
   * Scroll to the end-chapter section itself.
   *
   * A finished path has no active step, and scrollTofinalChaptersStep() only moves when
   * `finalChaptertepsInfo.activeStep > 0` — so on a completed path it finds nothing to scroll to and
   * the view never moves. The section element is what the learner should land on instead.
   */
  scrollToEndChapterSection(): boolean {
    const element = this.focusableEndChapter?.nativeElement
    if (!element) { return false }
    if (this.isMobile) {
      this.content?.scrollToPoint(0, element.offsetTop - 50, 100)
      return true
    }
    const container = this.scrollContainer?.nativeElement
    if (!container) { return false }
    const top = element.getBoundingClientRect()?.top
      - container.getBoundingClientRect()?.top + container.scrollTop - 50
    container.scrollTo({ top, behavior: 'smooth' })
    return true
  }

  /**
   * A completed path: nothing is in progress, so the end-of-step scroll has no step to aim at.
   *
   * Completion is `areAllChaptersStepsReviewed()` — the same predicate the completed-path UI uses, so
   * the scroll cannot disagree with what the screen shows. Testing only the LAST step would call a
   * path finished while an earlier one still read Resume.
   */
  private finishedWithNoActiveStep(): boolean {
    return this.areAllChaptersStepsReviewed() && !(this.finalChaptertepsInfo?.activeStep > 0)
  }

  async swipeToActiveSlide(time, val=null) {

    if (this.isMobile && !this.viewEntered) return;
     let chapterId = this.finalSortedChaptersInfo.findIndex((chapter) => chapter?.activeStep>0)
    if (this.isMobile) {
      setTimeout(() => {
         if (((this.finalChaptertepsInfo?.activeStep > 0 && val != 'middleChapter')|| this.areAllChaptersStepsReviewed()|| val=='endChapter') && this.focusableEndChapter && this.focusableEndChapter?.nativeElement) {
           if (!val || val != 'middleChapter' || val=='endChapter') {
            //  this.content.scrollToPoint(
            //    0,
            //    this.focusableEndChapter.nativeElement.offsetTop - 50, // small padding
            //    100
             //  );
             setTimeout(() => {
              this.scrollTofinalChaptersStep();
            }, 200);
             return;
           }
        }
        if (this.expandedIndex >= 0 && this.chapterCards && ((chapterId!=-1&& val!=='endChapter')|| val == 'middleChapter' || (this.areAllChaptersStepsReviewed() && !this.finalChaptertepsInfo?.totalSteps))) {
         let card
          if (val == 'middleChapter') {
            card = this.chapterCards.toArray()[this.expandedIndex];
          }
          else {
           card = this.chapterCards.toArray()[chapterId!=-1?chapterId:this.finalSortedChaptersInfo?.length-1];
          }
          console.log("this.chapterCards.toArray()",this.chapterCards.toArray(), this.scheduleDay,chapterId)
          if (card && card?.nativeElement) {
            // this.content.scrollToPoint(
            //   0,
            //   card.nativeElement.offsetTop - 50
            // );
            setTimeout(() => {
            this.scrollToMiddleChaptersStep();
          }, 200);
          }
        }
      }, 150);
    }
    else {
     
      setTimeout(() => {
        let focusableElement;
        if (((this.finalChaptertepsInfo?.activeStep > 0 && val != 'middleChapter')|| this.areAllChaptersStepsReviewed()|| val=='endChapter') && this.focusableEndChapter && this.focusableEndChapter?.nativeElement) {
          if (!val || val != 'middleChapter' || val=='endChapter') {
            focusableElement = this.focusableEndChapter
          }
        }
        if (this.expandedIndex >= 0 && this.chapterCards && ((chapterId!=-1 && val!=='endChapter') || val == 'middleChapter'|| (this.areAllChaptersStepsReviewed()&& !this.finalChaptertepsInfo?.totalSteps))) {
          if (val == 'middleChapter') {
            const card = this.chapterCards.toArray()[this.expandedIndex];
          if (card && card?.nativeElement) {
            focusableElement = card
          }
          }
          else {
            const card = this.chapterCards.toArray()[chapterId != -1 ? chapterId : this.finalSortedChaptersInfo?.length - 1];
            if (card && card?.nativeElement) {
              focusableElement = card
            }
          }
        }
        if (focusableElement?.nativeElement) {
          const elementRect = focusableElement?.nativeElement?.getBoundingClientRect();
          const parentContainer = this.scrollContainer?.nativeElement?.getBoundingClientRect();
          // Get position relative to scrollContainer
          const offsetTop = elementRect?.top - parentContainer?.top + this.scrollContainer?.nativeElement?.scrollTop -50;
          // this.scrollContainer?.nativeElement?.scrollTo({
          //   top: offsetTop,
          //   behavior: 'smooth', // Smooth scrolling effect
          // })
          if (this.expandedIndex >= 0 && this.chapterCards && ((chapterId != -1 && val !== 'endChapter') || val == 'middleChapter' || (this.areAllChaptersStepsReviewed() && !this.finalChaptertepsInfo?.totalSteps))) {

            setTimeout(() => {
              this.scrollToMiddleChaptersStep();
            }, 300);
          }
          if (((this.finalChaptertepsInfo?.activeStep > 0 && val != 'middleChapter') || this.areAllChaptersStepsReviewed() || val == 'endChapter') && this.focusableEndChapter && this.focusableEndChapter?.nativeElement) {

            setTimeout(() => {
              this.scrollTofinalChaptersStep();
            }, 300);
          }
          
        }
      
      }, time);
    }
  }
  ngAfterViewInit() {
    this.homeUIService.expandOnEnterAnimation()
    setTimeout(() => {
      const content = this.contentWrapper?.nativeElement;
      this.isScrollbarPresent = content?.scrollHeight > this.content['el']?.scrollHeight;
      this.checkScrollbar();
    }, 700);
  }
  
  closePage() {
    this.homeUIService.getLastModal();
    this.modalController.dismiss();
  }
  changeSubTextFont(stepTitle,index) {
   if(stepTitle) {
     // const element = stepTitle?.toArray()[index]?.nativeElement;
     const element = stepTitle?.el
    const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2');
    if(specificElement) {
      this.render.setStyle(specificElement, 'font-size', '20px');
      this.render.setStyle(specificElement, 'font-weight', '500');
      this.render.setStyle(specificElement, 'font-style', 'normal');
      this.render.setStyle(specificElement, 'line-height', '23.44px');
      this.render.setStyle(specificElement, 'font-family', 'Roboto');
     this.render.setStyle(specificElement, 'word-break', 'break-word');
     this.render.setStyle(specificElement, 'overflow', 'hidden');
     this.render.setStyle(specificElement, ' text-overflow', 'ellipsis');
     this.render.setStyle(specificElement, 'display', '-webkit-box');
     this.render.setStyle(specificElement, '-webkit-line-clamp', '2');
     this.render.setStyle(specificElement, 'margin-bottom', '8px');
     this.render.setStyle(specificElement, '-webkit-box-orient', 'vertical');

    }
  return true;
   }
   
  }

  goToStep(inout) {
    if (this.currentDay >= inout.startDay) {
      this.homeUIService.dismissAllModals().then(() => {
        if(this.currentDay !== inout.startDay){
          const pathProgress = localStorage.getItem(
            `PathProgress:User:${this.currentUser.id}:DayProgress:${this.path.id}:${inout.startDay}`
          )
          this.appState.set('screenId',pathProgress)
        }
        this.appState.set('isYourPathPrevious', true);
        this.router.navigate(['/content', inout.startDay]);
      });
    }
  }

  openToDoListModal(btn?) {
    if (this.sessionService.isTabletDevice() && btn=='to-do') {
      this.focusPlayBtn();
      setTimeout(() => {
        this.buttonOnBlur();
      }, 1000);
    }
    this.homeUIService.openNextComponent(MyCommitmentsComponent,'','desktop-todo')
  }
  openAllPathsComponent() {
    this.appState.set("isAllPaths", true);
    this.homeUIService.openNextComponent(AllPathsV2Component,'','desktop-allpath')
  }

  async openDailyStepsModal(comp?, compProps?,className?){
    if(this.homeUIService?.isDark()){
      const cust_class = className?className:'custom-modal'
      className = 'web-daily-steps-custom-modal dark-theme'
      }else{
        className = className?className:'custom-modal'
      }
      console.log("className", className);
    if(comp) {
      const modal = await this.modalController.create({
        component: comp,
        componentProps: compProps,
        // animated: false,
        cssClass: className,
        enterAnimation: this.animationService.slideInUpEnterAnimation,
        leaveAnimation: this.animationService.slideOutDownLeaveAnimation
       
      });
       await modal.present() 
      modal.onWillDismiss().then((data) => {
        if(data?.data?.isOpenNextStep) {
          modal.animated =false
         }
         if(data?.data?.isInstepTodoScreen) {
          this.homeUIService.unlockNextHabitLevel();
         }
         if (data?.data?.nextHabitUnlockFromToDoScreen == 'nextHabitUnlockFromToDoScreen') {
           setTimeout(() => {
             this.openDailyStepsModal(DailyStepsContentWebModalV2Component, { currentDay: data?.data?.currentDay, startFromScreen: 'daily-content-screen-todo' }, 'web-daily-steps-custom-modal');
           }, 600);
         }
        if (data?.data?.isAlertUnlockClosed) {
          this.appState.set("reviewingStepIndex", JSON.parse(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex);
          let chapterPosition= JSON.parse(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
          this.appState.set('isLevelClosedBeforeCommit', true)
          localStorage.removeItem('unlockingHabitStepDetails')
            this.openDailyStepsModal(DailyStepsContentWebModalV2Component,{currentDay: data?.data?.currentDay,startFromScreen: 'daily-content-screen-routine-sub-level',currentOpenedChapter:chapterPosition},'web-daily-steps-custom-modal')
         }

        if(this.dailyStepsArray?.[this.activeChapterIndex]?.steps?.[this.activestepIndex]?.stepStatus!=='Review' && this.currentDay==this.scheduleDay){
          this.getStepArrayInfo();
        }
       });
      modal.onDidDismiss().then(() => {
         this.isModalOpen = false;
      })
     
    }
   
   }

  findCurrentPlatform(){
    const ua = navigator.userAgent.toLowerCase();
    const hasTouch = navigator.maxTouchPoints > 1 || 'ontouchstart' in window;

    // Actual tablets (Android Tablets, iPads)
    const isTablet = /ipad|android(?!.*mobi)|tablet/i.test(ua);

    // Exclude touch laptops (Windows/macOS laptops with touchscreens)
    let  isLaptop = hasTouch && !isTablet && /windows|mac os|linux/i.test(ua);
    console.log("is tablet and isLaptop", isTablet, isLaptop)
    if(this.platform.is("mobileweb") && this.platform.is("ipad")&& (!isLaptop || !this.platform.is('desktop'))){
      return 'web-ipad';
    } else if(this.platform.is("mobileweb") && this.platform.is("tablet")&& (!isLaptop || !this.platform.is('desktop'))){
      return 'web-tablet';
    } else if(this.platform.is("mobileweb") && this.platform.is("ios") && !this.platform.is("ipad")){
      return 'web-ios';
    } else if(this.platform.is("mobileweb") && this.platform.is("android") && !this.platform.is("tablet")){
      return 'web-android';
    } else if(this.platform.is("ios") && this.platform.is("mobile")){
      return 'ios';
    } else if(this.platform.is("android") && this.platform.is("mobile")){
      return 'android';
    } else if(!this.isMobile){
      return 'web';
    } else {
      return 'web';
    }
  }

  openDailyStepContent(stepData,btn?,chapterIndex?) {
    let dailyStepsArray = this.appState.get('DailyStepsData');
    let chapterPos = chapterIndex >=0?chapterIndex:this.activeChapterIndex
    let stepIndex= dailyStepsArray[chapterPos]?.steps?.findIndex(s=>s.position==stepData?.position)
    console.log("stepData position ", stepData, stepIndex)
     if (stepData?.position !== 1 && (stepData?.position > this.scheduleDay && !dailyStepsArray[chapterPos]?.steps[stepIndex]?.stepStatus)) {
         this.isModalOpen =false
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
        return
     }
    
    this.appState.set('reviewingStepIndex', stepIndex);
    if (this.sessionService.isTabletDevice() && btn == "playBtn") {
      this.focusPlayBtn();
      setTimeout(() => {
        this.buttonOnBlur();
      }, 1000);
    }
    if (this.isModalOpen) {
      return
    }
    this.isModalOpen = true;
    this.appState.set("allowScreenCount", true);
    this.appState.set("currentScheduleDay",stepData?.position)
    if(stepData?.stepStatus =="Review"){
      this.replay(stepData?.position, stepIndex,chapterPos)
    }
    else if (stepData?.stepStatus == "Resume") {
       this.appState.set("screenStatus", 2);
      this.openDailyStepsModal(DailyStepsContentWebModalV2Component,{currentDay: stepData?.position},'web-daily-steps-custom-modal')
      // this.router.navigate(['/content', stepData?.step])
    }else{
      var i = stepData?.position - 1;
      if (stepData?.position !== 1 && (stepData?.position != this.scheduleDay || stepData?.position > this.scheduleDay )) {
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
         this.isModalOpen =false
        return
      }
       //commenting 668 frontend change
      const reqData = {
        user_id: this.currentUser.id,
        path_id: this.path.id,
        step: stepData?.position,
        step_id: stepData?.step?.id,
        platform: this.findCurrentPlatform(),
        original_step:stepData?.originalStep // need to change value once i get get update from bbackend
      };
      this.routineService.startTime(reqData).subscribe( (response) => {
        console.log('post request succesful', response);
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning("Error, please check!");
      });
    
      if (i == 0) {
        if(!this.isMobile) {
          // this.router.navigate(['/content', stepData?.step])
          localStorage.setItem('isBeginClicked','true')
          this.openDailyStepsModal(DailyStepsContentWebModalV2Component,{currentDay: stepData?.position},'web-daily-steps-custom-modal')

        }
        return;
      }
      let updateScheduleDay = i + 1;
      let data = {
        schedule_day: updateScheduleDay,
        user_id: this.currentUser.id,
      };
      // if (previousDayCompleted) {
        this.homev5Service.updateScheduleDay(data).subscribe(
          (response) => {
            if (response.success == true) {
              localStorage.setItem('isBeginClicked','true')
              this.appState.set("allowScreenCount", true);
              this.appState.set("LevelNumber", 1);
              this.appState.set("currentScheduleDay", updateScheduleDay);
              this.appState.set("scheduleDayForCurrentStep", updateScheduleDay);
              this.appState.set("indexOfLevel", 0);
              this.appState.set("levelUpdated", undefined);
              this.currentDay = this.appState.get("currentScheduleDay"); // LUMBA-1379
              this.scheduleDay = this.appState.get("scheduleDayForCurrentStep");
              this.openDailyStepsModal(DailyStepsContentWebModalV2Component,{currentDay:  !(i == undefined) ? i + 1 : stepData?.position},'web-daily-steps-custom-modal')

              return false;
            } else {
              this.toasterService.warning(this.i18n.t(
                "Server or connection issue. Please check your internet connection."
              ));
            }
          },
          (error) => {
            this.toasterService.warning(this.i18n.t(
              "Server or connection issue. Please check your internet connection."
            ));
            console.log("Response of update  error", error);
          }
        );
      // } else {
      //   this.toasterService.warning(this.i18n.t("Please complete previous step"));
      // }
    }

  }

   trackByChapter(index: number, chapter: any) {
    return chapter.id || chapter.position || index;
  }

  unlockReplay(stepData,chapterIndex?) {
    let index= stepData?.position;
    let dailyStepsArray = this.appState.get('DailyStepsData');
    let chapterPos = chapterIndex >=0?chapterIndex:this.activeChapterIndex
    let stepIndex= dailyStepsArray[chapterPos]?.steps?.findIndex(s=>s.position==stepData?.position)

    if (stepData?.position !== 1 && (stepData?.position > this.scheduleDay && !dailyStepsArray[chapterPos]?.steps[stepIndex]?.stepStatus)) {
         this.isModalOpen =false
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
        return
    }
    this.appState.set('reviewingStepIndex', stepIndex);
    this.appState.set("currentScheduleDay", index);
    this.appState.set("allowScreenCount", true);
    if(stepData?.stepStatus =='Review'){
      this.replay(stepData?.position, stepIndex, chapterPos)
    }
    else if(stepData?.stepStatus =='Resume'){
      this.router.navigate(['/content', index])
    } else {
       if (index !== 1 && (index != this.scheduleDay || index > this.scheduleDay )) {
        // this.toasterService.warning(this.i18n.t("Please complete previous step"));
        this.isModalOpen =false
         return
      }
       const reqData = {
        user_id: this.currentUser.id,
        path_id: this.path.id,
        step: stepData?.position,
        step_id: stepData?.step?.id,
        platform: this.findCurrentPlatform(),
        original_step: stepData?.originalStep
      };
      this.routineService.startTime(reqData).subscribe( (response) => {
        console.log('post request succesful', response);
      }, (error) => {
        console.log('Error: ', error);
        this.toasterService.warning("Error, please check!");
      });
      var i = index - 1;
      if (i == 0) {
        localStorage.setItem('isBeginClicked','true')
        this.router.navigate(['/content', index])
        return;
      }
      let updateScheduleDay = i + 1;
      let data = {
        schedule_day: updateScheduleDay,
        user_id: this.currentUser.id,
      };
      // if (this.dailyStepsArray[this.activeChapterIndex]?.steps[this.dailyStepsArray[this.activeChapterIndex]?.steps?.length-1]?.position < updateScheduleDay) {
      //   if (this.activeChapterIndex < this.dailyStepsArray?.length) {
      //     this.activeChapterIndex += 1;
      //     this.appState.set('currentActiveChapter', this.activeChapterIndex);
      //   }          
      // }
       if (index<=this.scheduleDay) {
        this.homev5Service.updateScheduleDay(data).subscribe(
          (response) => {
            if (response.success == true) {
              localStorage.setItem('isBeginClicked','true')
              this.appState.set("allowScreenCount", true);
              this.appState.set("LevelNumber", 1);
              this.appState.set("currentScheduleDay", updateScheduleDay);
              this.appState.set("scheduleDayForCurrentStep", updateScheduleDay);
              this.appState.set("indexOfLevel", 0);
              this.appState.set("levelUpdated", undefined);
              this.currentDay = this.appState.get("currentScheduleDay"); // LUMBA-1379
              this.scheduleDay = this.appState.get("scheduleDayForCurrentStep");
              this.router.navigate([
                "/content",
                !(i == undefined) ? i + 1 : this.scheduleDay,
              ]);

              return false;
            } else {
              this.toasterService.warning(this.i18n.t(
                "Server or connection issue. Please check your internet connection."
              ));
            }
          },
          (error) => {
            this.toasterService.warning(this.i18n.t(
              "Server or connection issue. Please check your internet connection."
            ));
            console.log("Response of update  error", error);
          }
        );
       } 
      else {
        this.toasterService.warning(this.i18n.t("Complete the previous step to unlock this step."));
      }
    }
    
  }

  replay(i, stepIndex, chapterPosition) {
    this.appState.set("isNewStepUnlocked", undefined);
    let screensViewed = this.appState.get('screensViewed')
    this.appState.set('allowScreenCount', undefined)
    let stepsArray;
    if (this.pathRegistration?.screensViewed) {
      stepsArray = this.homev5Service.removeDuplicates(this.pathRegistration?.screensViewed,"step");
    }else{
      stepsArray = screensViewed
    }   
    if (this.isMobile) {
      this.isModalOpen = false;
      if(chapterPosition>=0) {
      this.router.navigate([
        "/content",
        !(i == undefined) ? i : this.scheduleDay,
      ],{queryParams:{currentOpenedChapter:chapterPosition,currentOpenedStep: stepIndex}});
      }
      else {
        this.router.navigate([
          "/content",
          !(i == undefined) ? i : this.scheduleDay,
        ]);
      }
    }
   else {
    if(chapterPosition>=0) {
    this.openDailyStepsModal(DailyStepsContentWebModalV2Component,{currentDay:i,currentOpenedChapter:chapterPosition},'web-daily-steps-custom-modal')
    }
    else {
      this.openDailyStepsModal(DailyStepsContentWebModalV2Component,{currentDay:i },'web-daily-steps-custom-modal')
    }
   }
    return false;
  }
  loadSvgFile(path,pos?) {
    this.http.get(path, { responseType: 'text' })
      .subscribe(svgData => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgData, 'image/svg+xml');
        const primaryColor = getComputedStyle(document?.documentElement)?.getPropertyValue('--theme-color');
        let pathElements = svgDoc.querySelectorAll('stop');
       pathElements?.forEach(pathElement => {
        const currentColor = pathElement?.getAttribute('stop-color')
        if(pathElement?.getAttribute('stop-color')=='#8077E7'){
          pathElement?.setAttribute('stop-color', primaryColor); // Use the var(--color) notation to set the fill color dynamically         
        }
      
      });   
      const serializer = new XMLSerializer();
      const modifiedSvgData = serializer.serializeToString(svgDoc);
      const encodedData = encodeURIComponent(modifiedSvgData);
      if(path =='../../../assets/web_home_ui/white_circular_to-do.svg') {
        this.onFocuseCloseOut =`data:image/svg+xml,${encodedData}`;
      }
      if(path =='../../../assets/web_home_ui/black_circular-to-do.svg') {
        this.closeoutSvg =`data:image/svg+xml,${encodedData}`;
        this.startCloseout = this.closeoutSvg;
      }
      if (path == '../../../assets/web_home_ui/blur-play-btn.svg') {
        this.blurPlayButton = `data:image/svg+xml,${encodedData}`;
      }
      if(path =='../../../assets/web_home_ui/white_play_btn.svg') {
        this.onFocusPlayBtn =`data:image/svg+xml,${encodedData}`;
      } 
      else if(path =='../../../assets/web_home_ui/black_play_btn.svg'){
        this.startPlayButton =`data:image/svg+xml,${encodedData}`;
        this.playSvg =this.startPlayButton;
      }   
      });
  }
  focusPlayBtn()
  {
        console.log("entered focus method");
    this.isBtnFocused =true;
    if(this.areAllChaptersStepsReviewed()) {
      this.closeoutSvg = this.onFocuseCloseOut
    }
    else {
      this.playSvg =this.onFocusPlayBtn;
    }
  }
  buttonOnFocus(val) {
    if (!this.sessionService.isTabletDevice()) {
      if (this.areAllChaptersStepsReviewed()) {
        if (val == false) {
          this.closeoutSvg = this.startCloseout
        }
        else {
          this.closeoutSvg = this.onFocuseCloseOut
        }
      }
      else {
        if (val == false && ! this.isHovered) {
          this.playSvg = this.startPlayButton
        }
        else if (val == false && this.isHovered) {
          this.playSvg = this.blurPlayButton
        }
        else {
          this.playSvg =this.onFocusPlayBtn;
        }
      }
    }
  }
  contentOnFocus(val) {
    this.isHovered = val;
    this.buttonOnFocus(false);
  }
  openStepModal() {
    if (this.dailyStepsArray?.length > 0 && !this.areAllChaptersStepsReviewed()) {
      this.openDailyStepContent(this.dailyStepsArray[this.activeChapterIndex]?.steps[this.activestepIndex],'playBtn')
    }
    else if (this.dailyStepsArray?.length > 0 && this.areAllChaptersStepsReviewed()) {
      this.openToDoListModal('to-do');
    }
  }
  buttonOnBlur() {
    console.log("entered blur method");
    if(this.areAllChaptersStepsReviewed()) {
        this.closeoutSvg = this.startCloseout
    }
    else {
        this.playSvg = this.startPlayButton
     
    }
    this.isHovered = false;
  }
    
  onLeftSliderEnter() {
    if (this.sessionService.isTabletDevice()) {
      this.focusYourPath = false;
    } else {
      this.focusYourPath = true;
    }
  }

  onLeftSliderLeave() {
    this.focusYourPath =false
  }
  onScroll(event) {
    // Check for scrollbar presence during scrolling
    this.checkScrollbar(event);
  }

  private checkScrollbar(ev?) {
    const content = this.contentWrapper?.nativeElement;
    this.isScrollbarPresent = content?.scrollHeight > this.content['el']?.scrollHeight;
    const button = this.el?.nativeElement?.querySelector('#fixedButton');
    const divEle = document.getElementsByClassName('home-step-content-wrap');
    // if (divEle && ev) {
    //   divEle[0].setAttribute('style', 'height:auto !important;align-items:center; justify-content:center;display:flex;flex-wrap:wrap;align-content:center;');
    // }
    if ((ev || button) && this.isScrollbarPresent) {
      console.log("called");
      button?.classList?.add('web-start-btn-fixed');
    } else {
       let btn = document.getElementsByClassName("web-start-btn-fixed");
      if (btn && btn?.length>0) {
         divEle[0].setAttribute('style', 'height:auto !important;align-items:center; justify-content:center;display:flex;flex-wrap:wrap;align-content:center;');
      }
      
       //button?.classList?.remove('web-start-btn-fixed');

    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isTouchDevice = this.sessionService.isTabletDevice();
    this.checkScrollbar();
  }

  stripHtml(html: string): string {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const decoded = tmp.textContent || tmp.innerText || '';
    return decoded.replace(/<[^>]*>/g, '');
  }

  ngOnDestroy() {
    this.viewEntered = false;
    this.pendingRender = false;
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
